module.exports = __webpack_public_path__ + "static/media/card-content-video.879e37ad.svg";